import axios  from "axios"

export default {
    async getProfileData() {
        return await axios.get('/user/profile')
        .then(({data}) => data)
        .catch(error => {return Promise.reject(error); });
    },

    async updateProfileData(data) {
        return await axios.put('/user/profile', data)
        .then(({data}) => data)
        .catch(error => {return Promise.reject(error); });
    },
    async imageUpdate(data){
        console.log(data)
        return await axios.put('/user/profile/img', data)
        .then(({data}) => data)
        .catch( error => Promise.reject(error));
    },

    async sendEmailVerifyOTP() {
        return await axios.post('user/verify-email')
        .then(result => result)
        .catch( error => Promise.reject(error));
    }, 

    async verifyEmailOtp(data) {
        return await axios.put('user/verify-email', data)
        .then(result => result)
        .catch( error => Promise.reject(error));
    },

    async getLanguages() {
        return await axios.get('public/language')
        .then(result => result)
        .catch( error => Promise.reject(error));
    },
    async updatePassword(data) {
        return await axios.put('/user/password', data)
        .then(({data}) => data)
        .catch(error => {return Promise.reject(error.response); });
    },
}